import styled, { css } from 'styled-components';
import { StyledSlideListProps } from './SlideList.types';
import { StyledSliderProps } from '../Slider.types';

export const StyledSlideList = styled.ul<StyledSlideListProps>`
  ${(props) => props.customStyle}
`;

export const StyledSliderSlideElement = styled.li`
  ${({
    numberOfSlide,
    keyDataset,
    ...props
  }: {
    numberOfSlide: number;
    keyDataset: number;
  } & StyledSliderProps) => {
    if (props.transitionType && props.transitionType !== 'rotate') {
      return css``;
    }

    //keyDataset is a key based on where the item should locate from current. -1 is the equivalent of previous slide
    //translationPercentageForRotateTransition is a percentage value sned by props
    //Basic rotate idea: translate every item by their own size (every item have the same size), multiply by where they are located from current
    //When adding space between items, the same is done but you also need to add the space in calculation
    //EG with a keyDataset=-2 and spacing=10px : the translate will be -200% + -2 * 10px
    const transformValue = `calc(${
      keyDataset * props.translationPercentageForRotateTransition
    }% + ${keyDataset} * ${props.spacingForSlide})`;
    return css`
      --slider-item-key: ${keyDataset};
      transform: translate3d(${transformValue}, 0, 0);
      &.slide-list__slide {
        z-index: ${numberOfSlide - Math.abs(keyDataset)};
      }
    `;
  }};
`;
